import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashCan = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 29,
	height: 29,
	viewBox: "0 0 29 29",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "trash-can-a",
		d: "M7 7h5V5.5a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 0-.5.5V7zM2 7h4V5.5A1.5 1.5 0 0 1 7.5 4h4A1.5 1.5 0 0 1 13 5.5V7h5.5a.5.5 0 1 1 0 1H17v13a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8H.5a.5.5 0 0 1 0-1H2zm1 1v13a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3V8H3zm3.5 5a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .5-.5zm3-1a.5.5 0 0 1 .5.5v7a.5.5 0 1 1-1 0v-7a.5.5 0 0 1 .5-.5zm3 1a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .5-.5z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "trash-can-b",
			fill: "currentColor",
			children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#trash-can-a" })
		}), /* @__PURE__ */ _jsx("use", {
			fill: "currentColor",
			fillRule: "nonzero",
			xlinkHref: "#trash-can-a"
		})]
	})]
});
export default SvgTrashCan;
